/* eslint-disable-next-line primer-react/no-deprecated-flash -- Existing Flash usage should be migrated to Banner. */
import {Flash} from '@primer/react'

import styles from './EditingForkBanner.module.css'

export function EditingForkBanner({
  forkName,
  forkOwner,
  canCreatePullRequest,
}: {
  forkName: string
  forkOwner: string
  canCreatePullRequest?: boolean
}) {
  return (
    <Flash aria-live="polite" className={styles.Flash}>
      You’re making changes in a project you don’t have write access to. Submitting a change will write it to a new
      branch in your fork <b>{`${forkOwner}/${forkName}`}</b>
      {(canCreatePullRequest ?? true) ? ', so you can send a pull request' : ''}.
    </Flash>
  )
}
